import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';
import { useParams } from 'react-router-dom';

export const COnfigurationsBasicInfoComponent = ({
    selectConfigurations, handleInnerFormChange, sheduledType, PolicyOwnerType, accountTypesList, accountListLoading, accountTypesListLoading, accountsList,
}: any) => {
    const { id } = useParams();


    return (
        <>
            <AccordionContainer
                child={
                    <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="Name"
                            labelField="Name"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Name'
                                );
                            }}
                            type="text"
                            value={selectConfigurations?.Name}
                        />

                        <InputContainer
                            label="Level"
                            labelField="Text"
                            list={PolicyOwnerType}
                            isDisabled={selectConfigurations?.Id && selectConfigurations?.OwnerLevelId}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'OwnerLevelId'
                                );
                            }}
                            optionName='Choose Level'
                            type="select"
                            value={selectConfigurations?.OwnerLevelId}
                            valueField="Value"
                        />
                        <InputContainer
                            label="Account Type"
                            labelField="Name"
                            isLoading={accountTypesListLoading}
                            list={accountTypesList}
                            isDisabled={selectConfigurations?.Id && selectConfigurations?.OwnerTypeId}
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'OwnerTypeId',
                                );
                            }}
                            optionName='Choose Account Type'
                            type="select"
                            value={selectConfigurations?.OwnerTypeId}
                            valueField="Id"
                        />
                        <InputContainer
                            label="Account Name"
                            labelField="Name"
                            isLoading={accountListLoading}
                            list={accountsList}
                            isDisabled={selectConfigurations?.Id && selectConfigurations?.OwnerAccountId}
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'OwnerAccountId',
                                );
                            }}
                            optionName='Choose Account Name'
                            type="select"
                            value={selectConfigurations?.OwnerAccountId}
                            valueField="Id"
                        />


                        <InputContainer
                            label="Enabled"
                            name="Enabled"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'Enabled'
                                )
                            }}
                            type="checkbox"
                            value={selectConfigurations?.Enabled}
                        />
                    </div>
                }
                expandedPanel="BasicInfo"
                headerTitle="Basic Info"
            />

            <AccordionContainer
                child={
                    <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            isDisabled={Number(id) > 0}
                            label="Command"
                            labelField="Command"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(event.target.value, 'Command');
                            }}
                            type="text"
                            value={selectConfigurations?.Command}
                        />


                        <InputContainer
                            isDisabled={Number(id) > 0}
                            label="Schedule Command Type"
                            labelField="Text"
                            list={sheduledType}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'ScheduleCommandTypeId',
                                );
                            }}
                            optionName="Choose ScheduleCommandType"
                            type="select"
                            value={selectConfigurations?.ScheduleCommandTypeId}
                            valueField="Value"
                        />


                        <InputContainer
                            isDisabled={Number(id) > 0}
                            label="DisplayOrder"
                            labelField="DisplayOrder"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'DisplayOrder'
                                );
                            }}
                            type="number"
                            value={selectConfigurations?.DisplayOrder}
                        />

                        <div className='col-span-full'>
                            <InputContainer
                                isDisabled={Number(id) > 0}
                                label="Instruction"
                                name="Instruction"
                                onValueChange={(event: any) => {
                                    handleInnerFormChange(
                                        event,
                                        'Instruction'
                                    )
                                }}
                                type="rte"
                                value={selectConfigurations?.Instruction}
                            />
                        </div>

                    </div>
                }
                expandedPanel="BasicInfo"
                headerTitle="Configurations"
            />
        </>
    )
}

export default COnfigurationsBasicInfoComponent;
